'use strict';

var React = require('react');

var SvgMeasurementVolumeIcon = function SvgMeasurementVolumeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.5 5v3.042a3 3 0 0 0 .137.895l1.552 4.966a2 2 0 0 1-1.91 2.597h-6.559a2 2 0 0 1-1.909-2.597l1.552-4.966a3 3 0 0 0 .137-.895v-3.042h-.5a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 0 1.5h-.5Zm-5.5 3.042v-3.042h4v2.25h-.75a.75.75 0 0 0 0 1.5h.806c.034.214.084.427.149.634l.27.866h-4.95l.27-.866a4.5 4.5 0 0 0 .205-1.342Zm-.944 3.708h5.888l.813 2.6a.5.5 0 0 1-.477.65h-6.56a.5.5 0 0 1-.477-.65l.813-2.6Z"
  }));
};
SvgMeasurementVolumeIcon.displayName = "MeasurementVolumeIcon";

exports.SvgMeasurementVolumeIcon = SvgMeasurementVolumeIcon;
